import React from "react";
import { Box, Button, Typography } from "@mui/material";
import * as Sentry from "@sentry/react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          gap={2}
          px={3}
        >
          <Typography variant="h5" fontWeight={600}>
            Qualcosa è andato storto
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            Si è verificato un errore imprevisto. Ricarica la pagina per
            continuare.
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Ricarica pagina
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}
